import React from 'react'

import { faTrashUndo } from '@fortawesome/pro-light-svg-icons'

import classnames from 'classnames'

import { Box, CustomizableDashboard } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

import MessagePanel from '@components/MessagePanel'
import NotificationBannerLocation from '@components/NotificationBannerLocation'

import styles from './styles.module.scss'

interface ContentProps {
  campaignId: number,
  draggablePlaceholder?: React.ReactNode,
  id?: string,
  isDraggingOver?: boolean,
  modules?: { key: string, moduleId: string }[],
}

const Content = React.forwardRef((props: ContentProps, ref) => {
  const {
    campaignId, draggablePlaceholder, id, isDraggingOver, modules,
  } = props

  const campaignPayload = useCampaign({ id: campaignId })

  const {
    callbacks: {
      toggleHidden,
    },
    campaign: {
      hidden,
      sandbox,
    },
    updating,
  } = campaignPayload

  const archiveActionPayload = {
    callbacks: {
      actionFn: toggleHidden,
    },
    options: {
      confirmButtonColor: '#43ac6a',
      icon: 'warning',
      isBulkAction: false,
    },
    strings: {
      actionString: 'unarchive',
      confirmString: 'Are you sure?',
      entityName: 'campaign',
      toastText: 'Campaign Unarchived',
    },
  }

  const buildMessageTitle = () => {
    if (hidden) return 'Campaign is Archived'
    if (sandbox && !hidden) return 'Campaign is set to Test'
    return ''
  }

  const buildMessageDescription = () => {
    if (sandbox && !hidden){
      return 'This Campaign has been set to a test campaign. Test Campaigns will be excluded from some reports.'
    }
    return undefined
  }

  return (
    <Box
      className={classnames(styles.root, isDraggingOver ? styles.draggingOver : null)}
      flexDirection="column"
      marginRight={[0, 0, 'large']}
      width={['100%', '100%', 'calc(100% - 375px)']}
    >
      <NotificationBannerLocation
        boxProps={{ marginTop: 'large', marginBottom: 0 }}
        locationKey="agency.campaign.overview.banner"
      />

      <MessagePanel
        // @ts-expect-error TS2322
        actionPayload={hidden ? archiveActionPayload : undefined}
        buttonIcon={faTrashUndo}
        buttonText="Unarchive Campaign"
        description={buildMessageDescription()}
        entityProperty={hidden || sandbox}
        marginTop="large"
        title={buildMessageTitle()}
        updating={updating}
      />

      {/*
       // @ts-expect-error TS2322 */}
      <div ref={ref} style={{ flexGrow: 1, minHeight: '100vh' }}>
        {/*
         // @ts-expect-error TS2322 */}
        {modules && <CustomizableDashboard.ModuleRenderer modules={modules} parentId={id} />}
        {draggablePlaceholder}
      </div>
    </Box>
  )
})

export default Content
